document.addEventListener("DOMContentLoaded", function() {
    const button = document.getElementById('gokwik-buy-now');

    function shakeButton() {
      if (button.classList.contains('pendant-buy')) {
        button.classList.add('shake');
        setTimeout(() => {
          button.classList.remove('shake');
        }, 500); // duration of the shake animation (0.5s)
      }
    }

    function startShaking() {
      shakeButton(); // First shake
      setTimeout(shakeButton, 500); // Second shake after 0.5s
      setTimeout(() => {
        // Wait 3 seconds before starting again
        startShaking();
      }, 3500); // Total wait after two shakes (3.5s)
    }

    // Start the shaking process
    startShaking();
  });